<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <div v-show="el.IsDeleted != true" class="item-group" v-bind:class="{chosen: overelement == el}" :key="el.Id" v-for="el in Elements" @dragenter="mouseEnter1(el)" @mouseleave="mouseLeave1(el)">
      <div>{{el.key}}:{{el.value}}:{{el.type}}</div>
      <div>{{el}}</div>
      <settingseditor-nested-property v-if="el.type == 'object'" class="base-item" v-bind:value="getProperties(el.value)" @deleteItem="deleteItem" @clickItem="clickItem" />
    </div>
  </div>
</template>

<script>
  import draggable from "vuedraggable";
  
  var overelement = null;

  export default {
    name: "settingseditor-nested-property",
    components: {
     
    },
    data() {
      return {
        overelement
      }
    },
    methods: {
      getProperties(theObject){
      //something
        var properties = Object.entries(theObject);
        if (properties.length > 0)
          return properties;
        return theObject;
        /*
        var propertyNames = Object.keys(theObject);
        var properties = [];

        for (var i = 0; i < propertyNames.length; i++) {
          var prop = {};
          if (propertyNames[i] != "length" && propertyNames[i] != "__ob__" && theObject[propertyNames[i]] != theObject) {
            prop = { key: propertyNames[i].toString(), value: JSON.parse(JSON.stringify(theObject[propertyNames[i]])), type: typeof (theObject[propertyNames[i]]) };
            properties.push(prop);
            console.log(propertyNames[i].toString())
          }
        }
        */
        //console.log(JSON.stringify(properties))
        //return properties;
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      emitter(value) {
        this.$emit("input", value);
      },
      dragChanged(event) {
        if (event != null && event.added != null && typeof (event.added) != "underfined") {
          var parent = this.getParent(event.added.element);
          if (parent != null) {
            event.added.element.ParentId = parent.Id;
          }
          else {
            event.added.element.ParentId = null;
          }
        }

        if (event != null && event.moved != null && typeof (event.moved) != "underfined") {
          var parent = this.getParent(event.moved.element);
          if (parent != null) {
            event.moved.element.ParentId = parent.Id;
          }
          else {
            event.moved.element.ParentId = null;
          }
        }


      },
      dragStart(event) {
        //alert(event.item.getAttribute("data-type"));
        //$(event.item).replaceWith($('<div>Bar X - starting</div>'))

      },
      dragEnd(event) {
        //alert(event.item.type);
        //$(event.item).replaceWith($('<div>Bar X - ended</div>'))

      },
      dragUpdated(event) {
        //$(event.item).replaceWith($('<div>Bar X - updated</div>'))
        //alert(event.item.type);
      },
      dragCloned(event) {
        //alert(event.item.type);
        //$(event.item).replaceWith($('<div>Bar X - cloned</div>'))
      },
      dragSorted(event) {
        //$(event.item).replaceWith($('<div>Bar X - sorted</div>'))

      },
      dragMoved(event) {
        //$(event.item).replaceWith($('<div>Bar X - moved</div>'))

      },
      dragAdded(event) {
        //var t = $(event.item).children()[0].getAttribute("data-type")
        //var t = event.item.getAttribute("data-type")
        //alert("t:" + t + " id:" + event.item.id);
        //alert("t:" + t + " id:" + event.item.id);
        //$(event.item).html('something depending on t:' + t);

        //$(event.item).replaceWith($('something depending on t:' + t))
      },

      addItem(event) {
        //$(event.item).replaceWith($('<div>Bar X</div>'))
        //event.item = $('<div>test</div>')[0];
        //event.clone = $('<div>test</div>')[0];
        //alert($(event.item).html());

      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getParent(element) {
        var elements = this.getFlat(this.procedure.Elements);
        for (var i = 0; i < elements.length; i++) {
          for (var k = 0; k < elements[i].Elements.length; k++) {
            if (elements[i].Elements[k] == element)
              return elements[i];
          }
        }
        return null;
      },
      getFlat(elements) {
        var arr = [];
        for (var i = 0; i < elements.length; i++) {
          arr.push(elements[i]);
          var children = this.getFlat(elements[i].Elements);
          for (var k = 0; k < children.length; k++) {
            arr.push(children[k]);
          }
        }
        return arr;
      },
      testSomething(el) {
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      mouseEnter1(el) {
        this.overelement = el;
      },
      mouseLeave1(el) {
        this.overelement = null;
      }
    },
    components: {
      draggable
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: false,
          ghostClass: "ghost",
          chosenClass: "chosen",
          animation: 500,
          preventOnFilter: false,
          handle: ".handle"
        };
      },
      Elements: {
        get() {
          
          var theObject = this.value ? this.value : this.list;
          var properties = Object.entries(theObject);
          /*
          var propertyNames = Object.keys(theObject);
          var properties = [];
          for (var i = 0; i < propertyNames.length; i++) {
            var prop = {};
            if (propertyNames[i] != "length" && propertyNames[i] != "__ob__") {
              prop = { key: propertyNames[i].toString(), value: JSON.parse(JSON.stringify(theObject[propertyNames[i]])), type: typeof (theObject[propertyNames[i]]) };
              properties.push(prop);
            }
            //if (prop.type == "object") {
            //  if (Array.isArray(prop.value)) {
            //    prop.type
            //  }
            //}
              
          }
          */
          return properties;
        },
        set(value) {
          /*
          var newObject = {};
          for (var i = 0; i < value.length; i++) {
            newObject[]
          }
  
          this.procedure.Elements = value;
          */
        }
      }
      ,
      realValue() {
        return this.value ? this.value : this.list;
      }
    },
    props: {
      value: {
        required: false,
        type: [Object, Array] ,
        default: null
      },
      list: {
        required: false,
        type: [Object, Array],
        default: null
      },
      displaydropmessage: {
        required: false,
        type: Boolean,
        default: false
      },
      over: {
        required: false,
        type: Boolean,
        default: false
      },
    },
    mounted() {
    }
  };
</script>

<style scoped>

    /*
    .ghost {
      opacity: 0.5;
      background: #c8ebfb;
    }

    .item-group > .chosen {
        background-color:pink;
    }

    .item .ghost {
      background-color: pink;
    }

    .item .chosen {
      background-color: pink;
    }

    .item-group .chosen {
      background-color: pink;
    }

    .item-group > .item .chosen {
      background-color: pink;
    }

    .item-group > .item > .chosen {
      background-color: pink;
    }


    .chosen-outline {
      background-color: #ccc;
    }
  */

    .chosen {

    }

    .subdrop-hint {
      position: absolute;
      top: 59px;
      left: 45px;
      min-height:50px;
    }

  .icon-menu {
    /*color: #ccc;*/
  }

  .icon-menu {
    /*color: #000;*/
  }

    .handle {
      cursor: pointer;
    }

    .handle:hover {

    }

    .form-control:not(.border-bottom-1):not(.border-bottom-2):not(.border-bottom-3):focus {
      border-color: #DCDDDE;
    }

    .form-control:focus {
      outline: 0;
      box-shadow: 0 0 0 0 transparent,0 1px 0 #DCDDDE;
    }

    .item-container {
      margin: 0;
    }

    .item {
      padding: 5px;
      margin-top: 3px;
      
    }


  .item {
    min-width: 340px;
  }

  
  /*
    .item-group:focus {
      background-color: #fefefe;
      border: 2px dashed rgb(122, 176, 197);
      margin-top: 3px;
    }


    .item:hover {
      background-color: #fefefe;
      border: 2px dashed rgb(122, 176, 197);
      margin-top: 3px;
    }
    */
    .item-sub {
    margin: 0 0 0 1rem;
  }

    div {
      list-style: none;
    }

    .flip-list-move {
      transition: transform 0.5s;
    }

    .no-move {
      transition: transform 0s;
    }
</style>




// WEBPACK FOOTER //
// src/components/settingseditor/settingseditor-nested-property.vue